var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var AsyncStatus = /** @class */ (function () {
    function AsyncStatus(statusName) {
        if (statusName === void 0) { statusName = "INITIAL"; }
        this.statusName = statusName;
    }
    AsyncStatus.prototype.ensureNoScheduled = function () {
        clearTimeout(this.timeoutId);
    };
    AsyncStatus.prototype.scheduleClear = function () {
        var _this = this;
        this.ensureNoScheduled();
        this.timeoutId = window.setTimeout(function () {
            _this.statusName = "INITIAL";
        }, 10000);
    };
    AsyncStatus.prototype.runWithReset = function (action) {
        return __awaiter(this, void 0, Promise, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ensureNoScheduled();
                        return [4 /*yield*/, this.run(action)];
                    case 1:
                        result = _a.sent();
                        this.scheduleClear();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AsyncStatus.prototype.run = function (action) {
        return __awaiter(this, void 0, Promise, function () {
            var result, e_1, message;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.ensureNoScheduled();
                        this.statusName = "WORKING";
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, action];
                    case 2:
                        result = _b.sent();
                        this.statusName = "SUCCESS";
                        return [2 /*return*/, result];
                    case 3:
                        e_1 = _b.sent();
                        message = ((_a = e_1.message) !== null && _a !== void 0 ? _a : "").replace("GraphQL error: ", "");
                        this.statusName = { message: message };
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AsyncStatus.prototype, "isWorking", {
        get: function () {
            return this.statusName === "WORKING";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AsyncStatus.prototype, "isSuccess", {
        get: function () {
            return this.statusName === "SUCCESS";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AsyncStatus.prototype, "isError", {
        get: function () {
            return typeof this.statusName === "object";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AsyncStatus.prototype, "errorMessage", {
        get: function () {
            if (typeof this.statusName !== "object") {
                throw new Error("Not error status");
            }
            return this.statusName.message;
        },
        enumerable: false,
        configurable: true
    });
    return AsyncStatus;
}());
export default AsyncStatus;
